import baseConfig, { Config } from "../../utils/config";

// Specific configuration for Demo 3 - Electrical Mode
const demo4Config: Config = {
  ...baseConfig,

  enableHelperMethods: true,
  enableHelpersMethodsGroup_Highlight: false,
  enableHelpersMethodsGroup_Group: false,
  enableHelpersMethodsGroup_Manipulate: false,
  enableHelpersMethodsGroup_Insert: false,
  enableHelpersMethodsGroup_CustomCanvas: false,
  enableHelpersMethodsGroup_SpaceArea: false,
  enableHelpersMethodsGroup_RedlineArea: false,
  enableHelpersMethodsGroup_VizQueryDemo: true,
  enableHelpersMethodsGroup_Brookfield: false,
  enableHelpersMethodsGroup_UrbanEdge: false,
  enableHelpersMethodsGroup_UicEdu: false,
  enableHelpersMethodsGroup_Insuremep: false,


  enableAIChat: false,
  useAIChatV5: true,
  useAIChatV4: false,
  aiChatV2Endpoint: "/ai/v2/chat", // Endpoint for the new AI chat service
  aiChatV3Endpoint: "/ai/v3/search-spaces", // Endpoint for the V3 AI chat service
  aiChatV4Endpoint: "", // Endpoint for the V4 AI chat service
  aiChatV5Endpoint: "", // Endpoint for the V5 proxy (supports snowflake and python)
  aiChatV5Provider: "python" as "snowflake" | "python" | "snowflake-agent", // Provider for the V5 proxy endpoint
  aiChatV5Mode: "Test" as "Test" | "Prod", // Mode for the V5 proxy endpoint (defaults to "Test")
  omitSpaceObjectLayerHandling: false
};

export default demo4Config;
